import { useSelector } from 'react-redux';
import { ReducerKeys } from '../../config';
import { IState } from './reducer';
import useShallowEqualSelector from '../../../hooks/useShallowEqualsSelector';
import Environment from 'config/environment';

export const useHostDetails = (): IState['hostDetails'] => {
  return useShallowEqualSelector(
    (state: any) => (state[ReducerKeys.HOST_REDUCER] as IState).hostDetails
  );
};

export const useHostLogo = () => {
  const logo = useSelector(
    (state: any) =>
      (state[ReducerKeys.HOST_REDUCER] as IState).hostDetails.data?.settings?.[
        'cellock.theme.logoId'
      ]
  );
  return logo ? `${Environment.API_BASE_URL}/${logo}` : null;
};

export const useHostBackground = () => {
  const logo = useSelector(
    (state: any) =>
      (state[ReducerKeys.HOST_REDUCER] as IState).hostDetails.data?.settings?.[
        'cellock.theme.backgroundImage'
      ]
  );
  return logo ? `${Environment.API_BASE_URL}/${logo}` : null;
};
